import camaraObscura from "@/assets/thumb-camara-obscura.webp.asset.json";
import selfie from "@/assets/thumb-selfie.webp.asset.json";
import garden from "@/assets/thumb-garden.webp.asset.json";
import butoh from "@/assets/thumb-butoh.webp.asset.json";
import ecologies from "@/assets/thumb-ecologies.webp.asset.json";
import entities from "@/assets/thumb-entities.webp.asset.json";
import appropriation from "@/assets/thumb-appropriation.webp.asset.json";
import violence from "@/assets/thumb-violence.jpg.asset.json";
import symbiogenesis from "@/assets/thumb-symbiogenesis.webp.asset.json";
import weightOfFeeling from "@/assets/the-weight-of-feeling.webp.asset.json";
import weightOfFeelingPlate from "@/assets/the-weight-of-feeling-plate.webp.asset.json";
import apophenia from "@/assets/apophenia-pareidolia.png.asset.json";

/** Custom thumbnails per project slug (overrides the scraped cover). */
export const projectThumbs: Record<string, string> = {
  "camara-obscura": camaraObscura.url,
  selfie: selfie.url,
  "garden-of-dreams-and-nightmares-situated-between-the-loom": garden.url,
  "butoh-caipira": butoh.url,
  "ecologies-of-perception": ecologies.url,
  entities: entities.url,
  appropriation: appropriation.url,
  "topographies-of-violence": violence.url,
  symbiogenesis: symbiogenesis.url,
  "the-weight-of-feeling": weightOfFeelingPlate.url,
  "apophenia-and-pareidolia": apophenia.url,
};
